import axios from 'axios';

import { FAILURE, REQUEST, SUCCESS } from 'app/shared/reducers/action-type.util';
import { getProduct } from 'app/modules/products/products.reducer';

export const ACTION_TYPES = {
  FETCH_USER_CATEGORIES: 'categories/FETCH_USER_CATEGORIES',
  FETCH_PRODUCT_CATEGORIES: 'categories/FETCH_PRODUCT_CATEGORIES',
  RESET: 'select/RESET',
};

const initialState = {
  loading: false,
  fetchSuccess: false,
  fetchError: false,
  categories: null as any,
};

export type SelectedCategoriesState = Readonly<typeof initialState>;

// Reducer
export default (state: SelectedCategoriesState = initialState, action): SelectedCategoriesState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_USER_CATEGORIES):
    case REQUEST(ACTION_TYPES.FETCH_PRODUCT_CATEGORIES):
      return {
        ...state,
        fetchSuccess: false,
        loading: true,
      };

    case FAILURE(ACTION_TYPES.FETCH_USER_CATEGORIES):
    case FAILURE(ACTION_TYPES.FETCH_PRODUCT_CATEGORIES):
      return {
        ...state,
        loading: false,
        fetchSuccess: false,
        fetchError: true,
      };

    case SUCCESS(ACTION_TYPES.FETCH_USER_CATEGORIES):
    case SUCCESS(ACTION_TYPES.FETCH_PRODUCT_CATEGORIES):
      return {
        ...state,
        loading: false,
        fetchSuccess: true,
        fetchError: false,
        categories: action.payload.data,
      };

    case ACTION_TYPES.RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

// Actions
// USERS

export const getUserCategories = (login: string) => async dispatch => {
  await dispatch({
    type: ACTION_TYPES.FETCH_USER_CATEGORIES,
    payload: axios.get(`api/categories/users/${login}`),
  });
};

export const getProductCategories = (id: number) => async dispatch => {
  await dispatch({
    type: ACTION_TYPES.FETCH_PRODUCT_CATEGORIES,
    payload: axios.get(`api/categories/products/${id}`),
  });
};

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
